module.exports = __webpack_public_path__ + "static/media/17.cf7a9434.jpeg";